import { actionTypes } from '../../constants';

const content = ( state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONTENT_SUCCESS:
      return { 
          ...state , ...action.payload
        };
    default:
      return state;
  }
};

export default content;
